import React from "react";
import { CheckCircle2, Truck } from "lucide-react";
import { SHOP } from "@/constants/testIds";

export default function SuccessStage({ order, onClose }) {
  return (
    <div data-testid={SHOP.orderSuccess} className="flex-1 overflow-y-auto px-5 py-10 text-center">
      <div className="w-20 h-20 rounded-full bg-[#16A34A]/10 grid place-items-center mx-auto mb-5">
        <CheckCircle2 size={40} className="text-[#16A34A]" />
      </div>
      <h3 className="font-display text-2xl font-black text-gray-900">Order placed!</h3>
      <p className="text-sm text-gray-600 mt-2">
        Order ID: <span className="font-mono font-bold text-gray-900">#{order.id.slice(0, 8).toUpperCase()}</span>
      </p>
      <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FFD700] text-gray-900 font-bold text-sm">
        <Truck size={14} /> Fastest delivery on the way
      </div>
      <p className="mt-4 text-sm text-gray-600">
        Total paid on delivery: <span className="font-extrabold text-gray-900">₹{order.total.toLocaleString("en-IN")}</span>
      </p>
      <button onClick={onClose} className="mt-8 w-full h-11 rounded-lg bg-gray-900 hover:bg-gray-800 text-white font-bold text-sm">
        Continue Shopping
      </button>
    </div>
  );
}
